export default __webpack_public_path__ + "static/thanks-c12e168a4e6c1a628ce4c8f92a6379da.jpg";